import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { RenderNextStepProps, statetype } from "./types";
import { PrecertAPIResponse } from "../precert/types";
import { LoaderContext } from "src/context/loaderContext";
import useAppealButtonFunc from "src/hooks/useAppealButtonFunc";



const RenderNextStep: FC<RenderNextStepProps> = ({ kase, showHideModalForTreatment, setDataForCancelModal, getCaseListing }): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const navigate = useNavigate();
  const [precertPathParameters, setPrecertPathParameters] = useState<statetype>()
  const { submiAppealForCase, apiInPorgress } = useAppealButtonFunc();





  const { mutate: fetchPrecertMutate, data: fetchPrecertResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.FETCH_PRECERT, {}, {}, false);

  useEffect(() => {
    if (fetchPrecertResponse) {
      navigate(`/cases/${precertPathParameters && precertPathParameters.case_id}/precerts/${precertPathParameters && precertPathParameters.id}/edit`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPrecertResponse]);

  const navigateToPrecertForm = (caseId: number, precertId: number) => {
    const pathParams = {
      case_id: caseId,
      id: precertId
    }
    setPrecertPathParameters(pathParams)
    fetchPrecertMutate({}, pathParams)
  }
  const navigateToReviewPrecertForm = (caseId: number, precertId: number) => {
    // const pathParams = {
    //   case_id: caseId,
    //   id: precertId
    // }
    navigate(`/cases/${caseId}/precerts/${precertId}/review`);

    // setPrecertPathParameters(pathParams)
    // fetchPrecertMutate({}, pathParams)
  }




  const { loading: transferRxLoading, data: transferRxData, mutate: transferRxByCaseId } =
    useFetch(APIEndpoints.TRANSFER_RX, {}, { case_id: kase.id });

  useEffect(() => {
    if (transferRxData) {
      const { message } = transferRxData as unknown as { code: number; message: string; };
      showToast([message], ToastTypes.SUCCESS);
      getCaseListing();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxData]);

  useEffect(() => {
    if (transferRxLoading) setLoader();
    else hideLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxLoading]);


  const transferToSP = () => {
    // eslint-disable-next-line no-restricted-globals
    const res = confirm("Are you sure you want to transfer this prescription? This cannot be undone!");
    if (res)
      transferRxByCaseId()
  }




  const caseAction = [];

  if (kase.active_precert) {
    caseAction.push(
      <button
        className="btn btn-warning m-1 text-white"
        onClick={() => { navigateToPrecertForm(kase.id, kase.active_precert_id) }}
      >
        <i className="fas fa-clipboard-list"></i> Precert
      </button>)
  }
  // if(true){
  if (kase.date_of_treatment) {
    caseAction.push(
      <button
        className="btn btn-success m-1"
        onClick={() => showHideModalForTreatment({ isModalVisible: true, caseId: kase.id, prescriptionId: kase.prescription_id,buttonFor:"DateOfTreatment" })}
        >
        <i className="bi bi-clipboard-data me-2"></i> Date of Treatment
      </button>)
  }
  
  if (kase.buy_and_bill && !kase.cancelled_state) {
    caseAction.push(
      <button
        className="btn btn-success m-1"
        onClick={() => showHideModalForTreatment({ isModalVisible: true, caseId: kase.id, prescriptionId: kase.prescription_id,buttonFor:"BuyAndBill" })}
      >
        <i className="far fa-hospital"></i> Buy & Bill
      </button>)
  }
  ///blue karna ha
  // if (kase.precert_maximum) {
  //   caseAction.push(
  //     <button
  //       className="btn text-white m-1" style={{ backgroundColor: "#337ab7" }}
  //       onClick={() => navigateToReviewPrecertForm(kase.id, kase.pending_precert_id || 0)}
  //     >
  //       <i className="fas fa-clipboard-list"></i> Review
  //     </button>)
  // }
  // if (kase.precert_minimum) {
  //   caseAction.push(
  //     <button className="btn btn-danger m-1 "
  //       disabled={apiInPorgress}
  //       onClick={() => submiAppealForCase(kase.id, kase.appeal_precert_id)}
  //     >
  //       <i className="fas fa-clipboard-list"></i> Appeal
  //     </button>
  //
  //   )
  // }
  if (kase.xfer_rx_sp) {
    caseAction.push(
      <button
        className="btn btn-success m-1"
        onClick={transferToSP}
      >
        <i className="fas fa-prescription"></i> Xfer to SP
      </button>)
  }
  if ((kase.cancelled_state || kase.xfer_confirmed) && caseAction.length === 0) {
    caseAction.push(<p className="fs-6 mb-0">Review Case Notes</p>);
  }
  if (caseAction.length === 0) {
    caseAction.push(<p className="fs-6 mb-0">No Action Required</p>);

  }

  return (
    <>
      {caseAction}
    </>
  );
};

export default RenderNextStep;
